import {CerbaAuthService, httpFactory} from "@digicerba/common";
import {NgModule} from "@angular/core";
import {Http, RequestOptions, XHRBackend} from "@angular/http";
import {
  HttpClient,
  IAuditWebServiceClient,
  ICorrespondantWebServiceClient,
  IFacturesWebServiceClient,
  INotificationsCommonWebServiceClient,
  IUserInformationsWebServiceClient
} from "@resources/resources";

import {ResourcesClient} from "./resources.client";
import { CORRESPONDANT_CLIENT, USER_INFO_CLIENT } from "@digicerba/common/resources/tokens/injectionTokens";

var resources: Array<any> = [
  /** Liste des resources du fichier resources.ts*/
  ICorrespondantWebServiceClient,
  IAuditWebServiceClient,
  IUserInformationsWebServiceClient,
  INotificationsCommonWebServiceClient,
  IFacturesWebServiceClient,
  CerbaAuthService,
  { provide : CORRESPONDANT_CLIENT, useClass : ICorrespondantWebServiceClient},
  { provide : USER_INFO_CLIENT, useClass : IUserInformationsWebServiceClient}
];

@NgModule({
  providers: [...resources, {
    provide: Http,
    useFactory: httpFactory,
    deps: [XHRBackend, RequestOptions, CerbaAuthService]
  },
    {provide: HttpClient, useClass: ResourcesClient}]
})
export class ResourcesModule {

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-factures/digicerba-factures-web/src/angular/cerba/src/app/common/resources/resources.module.ts